module.exports = {
      id: "audio-replay-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#audio-replay",
      toString: function () {
        return this.url;
      }
    }